import React, { useMemo } from "react";
import HtmlReactParser from "html-react-parser";
import {
  FloorplanTabpanel,
  GalleryItem,
  GalleryTabpanel,
  HeroContainer,
  HeroInfoItem,
  HeroTablist,
  HeroTabpanel,
  HeroTabpanels,
  InfoTabpanel,
  SubtitleText,
  TourTabpanel,
  VideoBlockHeading,
  TrustpilotQuote,
} from "raffle-house-uikit";
import partner1 from "../../extensions/images/partners-image/bbc-new.png";
import partner2 from "../../extensions/images/partners-image/the_telegraph-new.png";
import partner3 from "../../extensions/images/partners-image/dm-logo.png";
import { doubleIcon, priceIcon } from "./icons";

import "./styles.scss";

const partnersGroup = [
  { text: "As seen in", src: null },
  { src: partner1, text: null },
  { src: partner2, text: null },
  { src: partner3, text: null },
];

const isProduction = process.env.NODE_ENV === "production";

const doublePrizeVideoUrls = {
  desktop: isProduction
    ? "https://raffle-house-production.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition.mp4"
    : "https://raffle-house-staging.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition.mp4",
  mobile: isProduction
    ? "https://raffle-house-production.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition-mobile.mp4"
    : "https://raffle-house-staging.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition-mobile.mp4",
  poster: isProduction
    ? "https://raffle-house-production.s3.eu-west-1.amazonaws.com/videos/08.06.2026/preview-competition.jpg"
    : "https://raffle-house-staging.s3.eu-west-1.amazonaws.com/videos/08.06.2026/preview-competition.jpg",
  mobilePoster: isProduction
    ? "https://raffle-house-production.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition-mobile-mobile.jpg"
    : "https://raffle-house-staging.s3.eu-west-1.amazonaws.com/videos/08.06.2026/competition-mobile-mobile.jpg",
};

export default function Hero(props) {
  const content = props.content.dreamHome;
  const isDouble = props.raffles?.length > 1;
  const isTopBadge = true;

  const videoUrls = useMemo(() => {
    if (isDouble) {
      return doublePrizeVideoUrls;
    }
    return {
      desktop: content.video.videoDesktopUrl,
      mobile: content.video.videoMobileUrl,
      poster: content.video.videoPreviewUrl,
      mobilePoster: content.video.videoPreviewMobileUrl,
    };
  }, [isDouble, content.video]);

  return (
    <HeroContainer>
      <HeroTablist />
      <HeroTabpanels>
        <HeroTabpanel id="tour">
          <TourTabpanel
            video={videoUrls.desktop}
            tabletVideo={videoUrls.desktop}
            mobileVideo={videoUrls.mobile}
            poster={videoUrls.poster}
            tabletPoster={videoUrls.poster}
            mobilePoster={videoUrls.mobilePoster}
          >
            <div
              className={
                "video-block-badge" +
                (isDouble ? " video-block-badge__double" : "") +
                (isTopBadge ? " video-block-badge__top" : "")
              }
            >
              {/* {isDouble ? (
                doubleIcon
              ) : ( */}
                <>
                  <span className="video-block-badge__price">
                    {content.video.badgePrice}
                  </span>
                  <img src={content.video.badgeUrl} alt="Win Dream Home" />
                </>
              {/* )} */}
            </div>
            <VideoBlockHeading>
              <SubtitleText isCentered variant={"primary"} color="color-1">
                {content.video.title}
                {/* 2 Dream Homes. Just&nbsp;1&nbsp;ticket.<br/>
                A £5.6M prize pool. */}
              </SubtitleText>
              {/* <div className="video-block-heading__tags">
                <p>Win the Home or Opt for Cash (Tax Free)</p>
                <p className="video-block-heading__tag-divider">|</p>
                <p>Guaranteed Draw</p>
                <p className="video-block-heading__tag-divider">|</p>
                <p>100% Yours</p>
              </div> */}
              <div className="video-block-buttons-block">
                <button
                  className="video-block-buttons__enter-now"
                  onClick={props.onCTAClick}
                >
                  Enter now
                </button>
                {isDouble && ( <button className="video-block-buttons__2-4-1-btn" onClick={props.onTwo4One} >
                  {/* <span className="video-block-buttons__2-4-1-icon">
                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13.368 4.93647C13.327 4.80434 13.2497 4.68769 13.1457 4.60102C13.0416 4.51435 12.9155 4.46146 12.783 4.44893L9.088 4.09888L7.62774 0.531334C7.51991 0.269227 7.27461 0.100098 7.00155 0.100098C6.7285 0.100098 6.4831 0.269227 6.37597 0.531334L4.91571 4.09888L1.22017 4.44893C0.949238 4.47502 0.719836 4.66651 0.635085 4.93647C0.593788 5.06872 0.590575 5.2107 0.625845 5.34483C0.661116 5.47897 0.733319 5.59936 0.833512 5.69109L3.62662 8.24679L2.80308 12.0318C2.74283 12.3101 2.84633 12.5979 3.06764 12.7649C3.18354 12.8529 3.32322 12.9002 3.46657 12.9001C3.58943 12.9001 3.71 12.8653 3.81539 12.7994L7.00155 10.8114L10.1871 12.7994C10.3014 12.8707 10.4333 12.9055 10.5663 12.8994C10.6993 12.8932 10.8277 12.8465 10.9355 12.7649C11.1568 12.5979 11.2603 12.3101 11.2 12.0318L10.3765 8.24681L13.1696 5.69112C13.2698 5.59939 13.342 5.479 13.3773 5.34486C13.4126 5.21073 13.4093 5.06871 13.368 4.93647Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  <p>2-4-1</p> */}
                  <p>View 2-4-1 Home Offer</p>
                </button> ) 
                }
              </div>
              
             
              {/* <div className="video-block-heading__partners-group">
                {partnersGroup.map((partner, index) => {
                  return (
                    <p key={index}>
                      {partner.src ? (
                        <img height="14px" src={partner.src} alt="partner" />
                      ) : (
                        partner.text
                      )}
                    </p>
                  );
                })}
              </div> */}
              <div className="video-block-heading__trustpilot">
                <TrustpilotQuote
                  author="John Paul"
                  text="Raffle House offer a genuine chance to win big while
                            supporting worthy charities. I particularly appreciate the independent selection process
                            which provides greater confidence of random selections.
                        "
                />
              </div>
            </VideoBlockHeading>
          </TourTabpanel>
        </HeroTabpanel>
        <HeroTabpanel id="gallery">
          <GalleryTabpanel>
            {content.gallery.map((image) => (
              <GalleryItem key={image._id}>
                <img
                  srcSet={`
                      ${image.image800Url} 800w,
                      ${image.image1600Url} 1600w,
                      ${image.image3840Url} 3840w,
                    `}
                  sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, 3840px`}
                  src={image.image3840Url}
                  alt="property"
                />
              </GalleryItem>
            ))}
          </GalleryTabpanel>
        </HeroTabpanel>
        <HeroTabpanel id="floorplan">
          <FloorplanTabpanel>
            <picture>
              <source
                srcSet={content.floorPlanUrl}
                media="(min-width: 768px)"
              />
              <source srcSet={content.floorPlanMobileUrl} />
              <img
                src={content.floorPlanUrl}
                sizes="(min-width: 768px) 1910px, 100vw"
                width={1910}
                height={720}
                alt="floorplan"
              />
            </picture>
          </FloorplanTabpanel>
        </HeroTabpanel>
        <HeroTabpanel id="info">
          <InfoTabpanel>
            {content.info.map((item, index) => {
              return (
                <HeroInfoItem
                  title={item.title}
                  description={item.description}
                  key={item._id}
                  index={index}
                  renderSubtitle={(string) => HtmlReactParser(string)}
                />
              );
            })}
          </InfoTabpanel>
        </HeroTabpanel>
      </HeroTabpanels>
    </HeroContainer>
  );
}
